import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { PercentOutlined, CalendarTodayOutlined } from "@mui/icons-material";
import apple from "assets/images/apple2.jpg";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useLazyGetDiscountByIdQuery } from "services/discount";
import { useLazyGetCouponByIdQuery } from "services/coupon";
const discount = {
  id: "1",
  banner: apple,
  name: "Fruits Sale",
  percentage: 20,
  description:
    "Enjoy a 20% discount on all fruits! Stock up on your favorite healthy snacks and get more for less. This offer is perfect for fruit lovers and health enthusiasts. Don't miss out on this juicy deal!",
  startDate: "5/12/24",
  endDate: "5/12/25",
};

export default function DiscountDetail() {
  const { id } = useParams();
  const [discountBIdApi] = useLazyGetCouponByIdQuery();
  const [discountById, setDiscountById] = useState({});
  const callDisCountByIdApi = async () => {
    try {
      const res = await discountBIdApi({ id }).unwrap();
      if (res?.status === 200) {
        setDiscountById(res?.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    callDisCountByIdApi();
  }, [id]);
  return (
    <Box sx={{ mx: "auto", py: 4 }}>
      {/* Header Section */}
      <CardHeader
        title={
          <Typography variant="h5" fontWeight="bold" ml={3}>
            {discountById?.discount_name_en || ""}
          </Typography>
        }
      />

      {/* Content Section */}
      <CardContent sx={{ px: 3, py: 2 }}>
        {/* Percentage and Dates */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <CardMedia
              component="img"
              image={discountById?.banner_image?.media_url}
              alt={`${discount.name} banner`}
              sx={{
                borderRadius: 2,
                height: 300,
                objectFit: "cover",
                mx: 2,
                mt: -1,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <PercentOutlined color="primary" />
              <Typography fontWeight="bold">
                {discountById?.discount_percentage}% Off
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" mt={1} gap={1}>
              <CalendarTodayOutlined color="primary" />
              <Typography>{`${discountById?.start_date} - ${discountById?.end_date}`}</Typography>
            </Box>
            <Box sx={{ mb: 3, mt: 1 }}>
              <Typography variant="h6">Description</Typography>
              <Typography color="text.secondary">
                {discountById?.description_en || "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Description */}
      </CardContent>
    </Box>
  );
}
